import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    footerWrapper: {
      width: "100%",
    },
    footerWrapperNoPadding: {
      "& footer > nav": {
        padding: 0,
      },
    },
    absoluteContainer: {
      position: "absolute",
    },
    stickyContainer: {
      position: "fixed",
    },
  },
  { name: "N0StickyFooter" },
);

export { useStyles };
